import { styled } from '@mui/material'

export const ExplanationImg = styled('img')({ width: '100%', marginBottom: 8, zIndex: -10 })
export const DownloadIcon = styled('img')({ height: 49, marginBottom: 8 })
